export const ECOMMERCE_ORDER_DEFAULT_DAYS_UNTIL_OVERDUE = 1;
export const REPLENISH_ORDER_DEFAULT_DAYS_UNTIL_OVERDUE = 3;

export const SHIPPING_CALC_TYPE_PERCENTAGE = 'percentage';
export const SHIPPING_CALC_TYPE_FIXED_PER_UNIT = 'fixed_per_unit';

export const BILLING_METHOD_INSTANT = 'instant';
export const BILLING_METHOD_NONE = 'none';

export const ENABLED = 'enabled';
export const DISABLED = 'disabled';

export const PERMISSION_STATUS = {
  SERVER_ERROR: 'SERVER_ERROR',
  DENIED: 'DENIED',
};
